import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-select',
  template: `
    <select class="form-select" [id]="id" [disabled]="disabled">
      <option *ngFor="let option of options" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  `,
  standalone: true,
  imports: [CommonModule]
})
export class ZikataSelectComponent {
  @Input() id = '';
  @Input() disabled = false;
  @Input() options: { value: string; label: string }[] = [];
}
